import React, { useState, useContext } from 'react';
import './App.css';
import AuthContext from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import OwnerDashboard from './pages/OwnerDashboard';
import WalkerDashboard from './pages/WalkerDashboard';

function App() {
  const { user, logout } = useContext(AuthContext);
  const [isLogin, setIsLogin] = useState(true);

  if (!user) {
    return (
      <div className="auth-container">
        {isLogin ? (
          <>
            <Login />
            <p>Don't have an account? <button onClick={() => setIsLogin(false)}>Register</button></p>
          </>
        ) : (
          <>
            <Register />
            <p>Already have an account? <button onClick={() => setIsLogin(true)}>Login</button></p>
          </>
        )}
      </div>
    );
  }

  return (
    <div className="app">
      <header className="topbar">
        <h1>🐕 Real Walkers</h1>
        <div className="user-info">
          <span>{user.email}</span>
          <button onClick={logout}>Logout</button>
        </div>
      </header>

      <main>
        {user.user_type === 'owner' ? <OwnerDashboard /> : <WalkerDashboard />}
      </main>
    </div>
  );
}

export default App;
